import React, { createContext, useState, useContext, ReactNode } from 'react';
import { THEME_COLORS } from './helpers';

type ThemeContextState = {
  themeColor: string;
  setTheme: (theme: string) => void;
};

const getTheme = (themeName: string) => {
  const theme = THEME_COLORS.find(item => item.id === themeName);

  return theme ?? getTheme('default');
};

const ThemeContext = createContext<ThemeContextState>({
  themeColor: '',
  setTheme: () => null,
});

type Props = {
  initTheme: string;
  children?: ReactNode;
};
export const ThemeProvider = ({ children, initTheme }: Props) => {
  const [themeColor, setThemeColor] = useState(getTheme(initTheme)?.hex ?? ''); // Default theme is 'light'

  const setTheme = (theme: string) => {
    setThemeColor(getTheme(theme)?.hex ?? '');
  };

  return (
    <ThemeContext.Provider value={{ themeColor, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
